<template>
  <div class="create-customer-drawer"
       v-if="drawer">
    <el-drawer :title="title"
               :visible.sync="drawer"
               :wrapperClosable="false"
               :close-on-press-escape="false"
               direction="rtl"
               @close="colseDrawer">
      <div class="base">
        <!-- <div class="add-item-title" style="margin-top: 0">基本信息</div> -->
        <el-form ref="form"
                 :inline="true"
                 :model="form"
                 :rules="rules"
                 label-width="80px"
                 size="mini"
                 label-position="left"
                 v-enterToNext="true">
          <p style="color: #e6a23c">提示：营业范围可能影响保险费率！</p>
          <div style="display: flex; justify-content: space-between">
            <div style="width: 85%">
              <el-form-item label="单位名称"
                            prop="name">
                <el-input v-model="form.name"
                          maxlength="20"
                          placeholder="请输入单位名称"></el-input>
              </el-form-item>
              <el-form-item label="统一社会信用代码"
                            label-width="136px"
                            class="code-input"
                            prop="businessCode">
                <el-input v-model="form.businessCode"
                          maxlength="50"
                          placeholder="请输入统一社会信用代码"></el-input>
              </el-form-item>

              <el-form-item label="联系人"
                            prop="linkman">
                <el-input v-model="form.linkman"
                          maxlength="20"
                          placeholder="请输入联系人"></el-input>
              </el-form-item>

              <el-form-item label="手机号码"
                            prop="linkPhone">
                <el-input v-model="form.linkPhone"
                          maxlength="11"
                          placeholder="请输入手机号码">
                </el-input>
              </el-form-item>
              <el-form-item label="邮编"
                            prop="postcode">
                <el-input v-model="form.postcode"
                          maxlength="50"
                          placeholder="请输入邮编"></el-input>
              </el-form-item>
              <el-form-item label="邮箱"
                            prop="email">
                <el-input v-model="form.email"
                          maxlength="50"
                          placeholder="请输入邮箱"></el-input>
              </el-form-item>
              <el-form-item label="省市区"
                            prop="provincialandCivicCode">
                <el-cascader v-model="form.provincialandCivicCode"
                             :options="options"
                             :props="{ expandTrigger: 'click' }"
                             @change="chooseArea"
                             ref="cascaderItem"
                             style="width: 100%"></el-cascader>
              </el-form-item>
              <el-form-item label="地址"
                            prop="address">
                <el-input v-model="form.address"
                          maxlength="20"
                          placeholder="请输入地址"></el-input>
              </el-form-item>
              <el-form-item label="营业范围"
                            prop="businessScope">
                <el-input type="textarea"
                          rows="4"
                          v-model="form.businessScope"
                          class="remarkInput"
                          placeholder="营业范围可能影响保险费率！"></el-input>
              </el-form-item>
            </div>
            <div style="border-left: 1px solid #e4e7ed; padding-left: 10px">
              <el-form-item label="营业执照"
                            prop="logo"
                            label-width="82px"
                            style="width: 100%">
                <el-upload :class="{ 'factory-hide-upload': isHideLogoUpload }"
                           action=""
                           :limit="1"
                           :file-list="form.logo"
                           accept=".jpg,.png"
                           list-type="picture-card"
                           :on-exceed="onExceed"
                           :on-preview="onPreview"
                           :before-remove="removeUploadLogo"
                           ref="uploadComapnayLogo"
                           :http-request="uploadComapnayLogo">
                  <i class="el-icon-plus"></i>
                  <div slot="tip"
                       class="el-upload__tip">
                    请上传.jpg/.png格式文件，文件大小不超过10M
                  </div>
                </el-upload>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
      <div class="rightPadding"></div>

      <div class="submit-bar">
        <el-button @click="
            () => {
              colseDrawer();
            }
          ">关 闭</el-button>
        <el-button type="primary"
                   :loading="submitLoading"
                   @click="onSubmit">确 定</el-button>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="imgDialog.show">
      <img width="100%"
           :src="imgDialog.url"
           alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { regionData } from "element-china-area-data";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    VueUeditorWrap,
  },
  props: {
    users: Array,
    title: String,
    drawerShow: Boolean,
    operation: String,
    customerInfo: Object,
    industryData: Array,
    cityList: Array,
  },
  data () {
    let validateEmail = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^\w+@[a-z0-9]+\.[a-z]+$/.test(value)) {
        callback(new Error("邮箱格式不正确"));
      } else {
        callback();
      }
    };
    let validatePhone = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error("手机号不正确"));
      } else {
        callback();
      }
    };
    let validatecreditCode = (rule, value, callback) => {
      //使用正则表达式进行验证手机号码
      if (
        !/^([0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}|[1-9]\d{14})$/.test(
          value
        )
      ) {
        callback(new Error("统一社会信用代码不正确"));
      } else {
        callback();
      }
    };
    return {
      submitLoading: false,
      drawer: false,
      companyScale: [],
      form: {
        license: [],
        logo: [],
        electronicProtocol: [],
      },
      imgDialog: {
        show: false,
        imgUrl: "",
      },
      currentUserInfo: null,
      rules: {
        name: [{ required: true, message: "请输入发薪单位", trigger: "blur" }],
        address: [
          { required: true, message: "请输入公司地址", trigger: "blur" },
        ],
        linkman: [
          { required: true, message: "请输入联系人名称", trigger: "blur" },
        ],
        linkPhone: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { validator: validatePhone, trigger: "blur" },
        ],
        email: [
          { required: true, message: "请输入邮箱", trigger: "blur" },
          { validator: validateEmail, trigger: "blur" },
        ],
        businessCode: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: "blur",
          },
          { validator: validatecreditCode, trigger: "blur" },
        ],
        logo: [{ required: true, message: "请上传营业执照", trigger: "blur" }],
        areaArr: [
          {
            required: true,
            message: "请选择省市区",
            trigger: ["blur", "change"],
          },
        ],
        businessScope: [
          { required: true, message: "请输入营业范围", trigger: "blur" },
        ],
        provincialandCivicCode: [
          { required: true, message: "请选择省市区", trigger: "blur" },
        ],
        postcode: [{ required: true, message: "请输入邮编", trigger: "blur" }],
      },
      personForm: {},
      manageInfoForm: {
        contractDate: [],
      },
      invoiceForm: {},
      needInvoice: false,
      companyId: "00000000-0000-0000-0000-000000000000",
      receiver: {
        principal: [],
        own: [],
        other: [],
      },
      customenContacts: [],
      options: regionData,
    };
  },
  computed: {
    isHideLogoUpload: function () {
      return this.form.logo.length == 1;
    },
    isHideLicenseUpload: function () {
      return this.form.license.length == 1;
    },
  },
  created () {
    // this.getCompanyScaleData();
  },
  methods: {
    chooseArea (value) {
      //区域地址改变
      //展示的你选择的值 是一个areaCode
      let areaTextArr = "";
      let arr = this.$refs["cascaderItem"].getCheckedNodes()[0].pathNodes;
      arr.forEach((i) => {
        areaTextArr = areaTextArr + i.label;
      });
      this.form.provincialandCivicRegion = areaTextArr;
    },

    validateForm (formName) {
      let isValidate = false;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          isValidate = true;
        } else {
          isValidate = false;
        }
      });
      return isValidate;
    },
    onSubmit () {
      if (!this.validateForm("form")) return;
      this.submitLoading = true;

      let sendData = {
        name: this.form.name,
        creditCode: this.form.businessCode,
        address: this.form.address,
        contactName: this.form.linkman,
        contactPhone: this.form.linkPhone,
        postcode: this.form.postcode,
        businessScope: this.form.businessScope,
        provincialandCivicCode: this.form.provincialandCivicCode.toString(),
        provincialandCivicRegion: this.form.provincialandCivicRegion,
        businessLicencePath: this.form.logo[0]?.url || "",
        email: this.form.email,
      };
      console.log(sendData);

      if (this.companyId != "00000000-0000-0000-0000-000000000000") {
        sendData.id = this.companyId;
      }

      this.$api.Insurance.InsureUnitEdit(sendData).then((res) => {
        this.submitLoading = false;
        if (res.error === false) {
          this.$message.success("保存成功");
          this.$emit("refreshData");
        } else {
          this.$message.error(res.msg);
        }
        this.colseDrawer();
        console.log("error=false");
        this.companyId = "00000000-0000-0000-0000-000000000000";
      });
    },
    uploadComapnayLogo (fileObj) {
      this.submitLoading = true;
      if (fileObj.file.size > 1024 * 1024 * 10) {
        this.$refs.uploadComapnayLogo.clearFiles();
        this.$message.warning(
          "文件不符合规则（图片大小不超过 10M），请重新上传~"
        );
        this.submitLoading = false;

        return;
      }
      this.uploadSingleImage(fileObj, "logo");
    },

    uploadSingleImage (fileObj, imgType) {
      // const formData = new FormData();
      // formData.append("file", fileObj.file);
      this.$api.upload
        .uploadSingleImage(fileObj.file)
        .then((res) => {
          this.submitLoading = false;

          if (res.code === 0) {
            this.OcrBusinessLicense(res.data[0]);
            this.form[imgType].push({
              name: fileObj.file.name,
              url: res.data[0],
            });
          } else {
            this.$message.error(res.msg);
          }
        })
        .catch((error) => {
          this.submitLoading = false;

          if (error.response?.status == 400) {
            this.$message.warning("请上传jpg、png格式的图片");
            this.form[imgType] = [];
          }
        });
    },
    // 营业执照的识别
    OcrBusinessLicense (url) {
      let sendData = {
        httpUrl: "https://" + url,
      };
      this.$api.thirdyParty.OcrBusinessLicense(sendData).then((res) => {
        if (res.code === 0) {
          this.$set(this.form, "name", res.data.companyName);
          this.$set(this.form, "businessCode", res.data.socialCreditCode);
          this.$set(this.form, "address", res.data.address);
          this.$set(this.form, "linkman", res.data.legalPerson);
          this.$set(this.form, "businessScope", res.data.businessScope);


        } else if (res.code == 2) {
          this.removeUploadLogo();
          this.$message.error("请上传正确的营业执照");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    onExceed (files, fileList) {
      this.$message.warning("只允许上传一张图片，请移除已上传图片后再进行操作");
    },
    onPreview (file) {
      console.log("dfsfd========s", file);
      this.imgDialog.show = true;
      this.imgDialog.url = file.url;
    },
    removeUploadLogo () {
      this.form.logo = [];
    },
    colseDrawer () {
      this.$emit("colseDrawer");
    },
    fillFormData (customerInfo) {
      console.log(customerInfo);
      this.companyId = customerInfo.id;
      // 基本信息
      this.$set(this.form, "name", customerInfo.name);
      this.$set(this.form, "businessCode", customerInfo.creditCode);
      this.$set(this.form, "address", customerInfo.address);
      this.$set(this.form, "email", customerInfo.email);
      this.$set(this.form, "linkman", customerInfo.contactName);
      this.$set(this.form, "linkPhone", customerInfo.contactPhone);
      this.$set(this.form, "postcode", customerInfo.postcode);
      this.$set(
        this.form,
        "provincialandCivicCode",
        customerInfo.provincialandCivicCode.split(",")
      );
      this.$set(this.form, "businessScope", customerInfo.businessScope);
      customerInfo.businessLicencePath &&
        this.form.logo.push({
          url: customerInfo.businessLicencePath,
        });
    },
  },
  watch: {
    drawerShow (val) {
      if (val == true) {
        this.$nextTick(() => {
          this.$refs["form"].clearValidate();
        });
      }

      this.drawer = val;
      if (this.drawer == false) {
        this.companyId = "00000000-0000-0000-0000-000000000000";
        this.form = {
          license: [],
          logo: [],
          electronicProtocol: [],
        };
        return;
      }
      if (this.operation == "edit") {
        console.log(this.customerInfo);
        this.fillFormData(this.customerInfo);
        // this.setCustomenContacts(this.customerInfo);
      } else {
        // this.setInitReceiver();
      }
    },
  },
};
</script>

<style lang="less">
.factory-hide-upload {
  .el-upload--picture-card {
    display: none;
  }

  .el-upload__tip {
    margin-top: 0;
  }
  .el-upload-list--picture-card .el-upload-list__item {
    width: 170px !important;
    height: 146px !important;
  }
}
.add-item-title {
  font-size: 16px;
  font-weight: bold;
  margin: 20px 0;
}
.create-customer-drawer {
  .el-drawer {
    width: 78% !important;
    .el-drawer__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 0;
      padding-bottom: 15px;
    }
    .el-drawer__body {
      // display: flex;
      background-color: rgba(0, 0, 0, 0.03);
    }
  }
  .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: auto;
  }
  .el-date-editor--daterange.el-input__inner {
    width: auto;
  }
  .el-date-editor .el-range-separator {
    width: 10%;
  }
  .base {
    width: 80%;
    height: 100%;
    float: left;
    padding: 17px 20px 60px 20px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: #fff;
    .el-form-item {
      width: 48%;
      .el-form-item__content {
        width: 54%;
      }
      .el-select {
        width: 100%;
      }
    }
    .code-input {
      .el-form-item__content {
        width: calc(54% - 60px);
      }
    }
    .form-item-block {
      width: 100%;
      .el-form-item__content {
        width: 90%;
      }
    }
  }
  .rightPadding {
    width: 20%;
    height: 100%;
    float: right;
    // background-color: rgba(0, 0, 0, 0.03);
  }
}

.submit-bar {
  position: absolute;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 10px 0;
  background-color: #fff;
  text-align: center;
  border-top: 1px solid #ddd;
  padding-right: 20px;
  .el-button {
    padding: 8px 20px;
  }
}
</style>
